<template>
    <div class="content">
        <img src='https://preprod.api.defipix.fr/logos/logo_bg_white.png' alt="logo defipix" class="logoDP">        
        <div v-if="this.$route.query.reservation" class="btnBack" @click="closeTab()">
            <img src='https://preprod.api.defipix.fr/logos/retour_200.png' alt="logo defipix" class="imgBack">
            <p>Retourner a votre reservation</p>
        </div>
        <List :options="options" :booths="booths" />
    </div>
</template>

<script>

import axios from 'axios';
import JQuery from 'jquery';
let $ = JQuery;
import List from '../components/Options/List';

export default {    
    title: 'Défipix.fr | Nos options',
    data() {
        return {
            options: [],
            booths: [],
        }
    },
    mounted: function () {
        this.getOptions();
        this.getBooths();
    },
    methods: {
        async getOptions() {
            try {
                const response = await axios.get('https://preprod.api.defipix.fr/option');
                this.options = response.data;
                this.sortByBooth();
            } catch (error) {
                console.error(error);
            }
        },
        async getBooths() {
            try {
                const response = await axios.get('https://preprod.api.defipix.fr/booth');
                this.booths = response.data;
            } catch (error) {
                console.error(error);
            }
        },
        listBooths(list) {
            if (!list) return null;
            let result = [];
            list.forEach((element, index) => {
                this.booths.forEach((element2, index2) => {
                    if (element === element2.id) {
                        let booth = {
                            name: element2.name
                        }
                        result.push(booth);
                    }
                })
                
            });
            return result;
        },
        sortByBooth() {
            let boothQuery = this.$route.query.booth ? this.$route.query.booth : null;
            if (!boothQuery) return;
            let arr2 = [];
            this.options.forEach(element => {
                element.booth = element.booth ? element.booth : [];
                if (JSON.stringify(element.booth).includes(boothQuery)) {
                    arr2.push(element);
                }
            });
            this.options = arr2;
        },
        closeTab() {
            window.close();
        }
    },
    components: {
        List
    }
}

function waterFloat(elm,t,d,v){
	var i = elm;
	var runIt = function (elm,t,d,v) {
		elm.animate({top:'+='+v},t,"linear",function(){
			$({deg: -d}).animate({deg: d}, {
				duration: t,
				step: function(now){
					elm.css({
						transform: "rotate(" + now + "deg)"
					});
				}
			},"linear");
			elm.animate({top:'-='+v},t,"linear",function(){
				$({deg: d}).animate({deg: -d}, {
				duration: t,
				step: function(now){
				elm.css({
					transform: "rotate(" + now + "deg)"
					});
				}
			},"linear");
				runIt(elm,t,d,v);
			});	
		});
	}
	runIt(i,t,d,v);
}

</script>

<style scoped>
.content {
    padding-bottom: 2em;
    max-width: 82em;
    width: 90%;
    margin: auto;  
}

.logoDP {
    max-width: 15em;
    margin: auto;
    display: block;
}

.btnBack {
    z-index: 1;
    position: fixed;
    bottom: 3em;
    left: 3em;
    background-color: #25327B;
    color: #fff;
    padding: 1em;
    width: 12em;
    text-align: center;
    border-radius: 10px;
    box-shadow: 0px 0px 5px 0px #aaa;
}

.btnBack:hover {
    cursor: pointer;
}

.imgBack {
    display: block;
    margin: auto;
    width: 5em;
    margin-bottom: 1em;
}

@media only screen and (max-width: 765px) {

    .btnBack {
        display: flex;
        flex-direction: row;
        align-items: center;
        width: 15em;
        margin: auto;
        left: 0;
        right: 0;
    }

    .imgBack {
        width: 3em;
        margin: 0 1em 0 0;
    }

    .btnBack>p {
        margin: 0;
    }
}

</style>


// WEBPACK FOOTER //
// src/router/Options.vue